/* eslint-disable */ const colors = {
  "primary": "#282423",
  "secondary": "#FEB308",
  "sidebarActiveItemColor": "#282423"
}; export default colors
